import React from 'react'
import { ComponentLookupObj, KeyValPair } from './types'
import {
  BankAccounts,
  CreditCardAccounts,
  DebtPlan,
  HomeLoans,
  InvestmentAccounts,
  Vehicles,
} from '../components'

export const lobComponents: ComponentLookupObj = {
  DEPOSIT: <BankAccounts key="BankAccountsComponent" />,
  INVEST: <InvestmentAccounts key="InvestmentAccountsComponent" />,
  MORTGAGE: <HomeLoans key="HomeLoansComponent" />,
  AUTO: <Vehicles key="VehiclesComponent" />,
  DEBT_PLAN: <DebtPlan key="DebtPlanComponent" />,
  CC: <CreditCardAccounts key="CreditCardsComponent" />,
}

export const reorderListItemLabel: KeyValPair = {
  INVEST: 'Investment Accounts',
  DEPOSIT: 'Bank Accounts',
  INVW: 'Wealth Management', // this gets updated where it is consumed in the AccountItemType component
  INVA: 'Robo Portfolio', // this gets updated where it is consumed in the AccountItemType component
  INVS: 'Self-Directed',
  CHECKING: 'Interest Checking',
  SAVINGS: 'Savings',
  CD: 'CDs',
  IRA: 'IRAs',
  MORTGAGE: 'Home Loans',
  AUTO: 'Vehicles',
  DEBT_PLAN: 'Plans',
  CC: 'Credit Cards',
  PLATINUM: 'Platinum',
  EVERYDAY: 'Everyday',
  UNLIMITED: 'Unlimited',
}
